import { utilsActions } from '../Reducers/UtilsReducer';

export const closeModal = async (dispatch) => {
  await dispatch(utilsActions.setModal(false));
};
export const openModal = async (dispatch) => {
  await dispatch(utilsActions.setModal(true));
};
